var map = {
	"./search-results.de-CH.json": 1028,
	"./search-results.de-DE.json": 1029,
	"./search-results.en-CA.json": 1030,
	"./search-results.en-GB.json": 1031,
	"./search-results.en-IN.json": 1032,
	"./search-results.en-ME.json": 1033,
	"./search-results.en-US.json": 1034,
	"./search-results.es-EM.json": 1035,
	"./search-results.es-ES.json": 1036,
	"./search-results.fr-BE.json": 1037,
	"./search-results.fr-CA.json": 1038,
	"./search-results.fr-CH.json": 1039,
	"./search-results.nl-BE.json": 1040,
	"./search-results.nl-NL.json": 1041,
	"./search-results.pl-PL.json": 1042,
	"./search-results.pt-BR.json": 1043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1027;